import type { FieldType, FieldWidth } from '@platform/core/types';

/** Типи нового поля в конструкторі (прототип v4: текст, багаторядковий текст, число, список, дата, користувач, теги). */
export const newFieldTypes: readonly FieldType[] = ['text', 'textarea', 'number', 'select', 'date', 'user', 'tags'];

/** Варіанти ширини поля у формі (FORM_LAYOUT §3): «Авто» (за типом) і явні S, M, L. */
export const fieldWidths: readonly FieldWidth[] = ['S', 'M', 'L'];

/** Типи для вибору в рядку поля: власний тип поля першим, якщо його немає серед типів нового поля (ітерація, напрям, посилання). */
export function typeChoicesOf(type: FieldType): FieldType[] {
  return newFieldTypes.includes(type) ? [...newFieldTypes] : [type, ...newFieldTypes];
}
